import { Button, ReminderIcon } from '@all-manager/design-system-v2';
import FullPageLayout from '../../../layout/FullPageLayout/FullPageLayout';
import CalendarPlanning from '../components/CalendarPlanning/CalendarPlanning';
import UpcomingRemindersDrawer from '../components/UpcomingRemindersDrawer/UpcomingRemindersDrawer';
import useUpcomingRemindersDrawer from '../components/UpcomingRemindersDrawer/useUpcomingRemindersDrawer';

export default function Calendar() {
  const upcomingReminders = useUpcomingRemindersDrawer();

  return (
    <FullPageLayout
      htmlTitle="Calendrier"
      title="Calendrier"
      fixedHeader
      action={(
        <Button
          variant="outlined"
          size="small"
          startIcon={<ReminderIcon />}
          onClick={upcomingReminders.handleOpen}
        >
          Rappels à venir
        </Button>
      )}
    >
      <CalendarPlanning />

      <UpcomingRemindersDrawer
        isOpen={upcomingReminders.isOpen}
        onClose={upcomingReminders.handleClose}
        reminders={upcomingReminders.reminders}
        hasMore={upcomingReminders.hasMore}
        isLoading={upcomingReminders.isLoading}
        isLoadingMore={upcomingReminders.isLoadingMore}
        isLoadMoreError={upcomingReminders.isLoadMoreError}
        onLoadMore={upcomingReminders.handleLoadMore}
      />
    </FullPageLayout>
  );
};
